
function getPixelDataFromImage(img)
{
	var canvas = document.createElement('canvas');
	var ctxt = null;
	canvas.width = img.width;
	canvas.height = img.height;
	ctxt = canvas.getContext('2d');
	ctxt.drawImage(img, 0, 0);
	return ctxt.getImageData(0, 0, img.width, img.height);
}

function imageToArray(url_or_img, callback) 
{
	var pixels = null;
	if (url_or_img instanceof Image)
	{
		pixels = getPixelDataFromImage(url_or_img);
		callback(null, new Uint8Array(pixels.data), url_or_img );
	}
	else
	{
		var img = new Image();
		img.crossOrigin = "Anonymous";
		img.onload = function() 
		{
			pixels = getPixelDataFromImage(img);
			callback(null, new Uint8Array(pixels.data), img);
		};
		img.onerror = function(err) {	callback(err) 	};
		img.src = url_or_img;
	}
}

export { imageToArray, getPixelDataFromImage }